<!-- 公告通知 -->
<template>
  <div class="el-notice" :style="(borderShow?'border: 1px solid #DEDEDE;padding: 20px 20px 0;':'')">
    <el-row class="content_block" :style="(hei?'height:'+hei:'')">
      <template v-if='$Base64.decode($ls.get($getKeyInfo("userType"))) == 1'>
        <TitleInfo title="通知公告" :titleImg="info" :showClose="false"></TitleInfo>
      </template>
      <template v-if='$Base64.decode($ls.get($getKeyInfo("userType"))) == 2'>
        <div class="_Info_box">
          <el-row class="title_head">
            <span class="class_img">
              <el-image class="title_img" :src="info"></el-image>
            </span>
            <span>公告管理</span>
            <el-link style="float: right;" :underline="false" icon="el-icon-circle-plus-outline" type="primary" @click="addNotice">新增公告</el-link>
          </el-row>
          <el-divider></el-divider>
        </div>
      </template>
      <el-row :class="(borderShow?'':'pl20 pr20') + ' notice_list'" :style="borderShow?'border: 1px solid #DEDEDE;':''">
          <template v-for="(item, index) in noticeList" >
            <el-row :class="borderShow?'p15':'pt15 pb15'" :key="index">
              <el-col :span="16" class="limit_line_one" >
                <template v-if="!item.studentIsRead && $Base64.decode($ls.get($getKeyInfo('userType'))) != 2">
                  <div class="wdon"></div>
                </template>
                {{item.noticeTitle}}
              </el-col>
              <el-col :span="5" class="limit_line_one" style="text-align: right;">{{item.createTime}}</el-col>
              <el-col :span="3" class="t_r">
                <el-link type="primary" :underline="false" @click="lookNotice(item)">查看详情</el-link>
              </el-col>
            </el-row>
            <template v-if="index < noticeList.length - 1">
              <el-divider></el-divider>
            </template>
          </template>
          <el-empty v-if="noticeList.length <= 0" ></el-empty>
      </el-row>
      <template v-if="pagingShow">
        <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-sizes="[5, 12, 20, 40]"
            :page-size="limit"
            background
            :hide-on-single-page="true"
            layout="sizes, prev, pager, next,jumper"
            :total="total">
          </el-pagination>
        </div>
      </template>
      <template v-else>
        <el-row class="mb20"></el-row>
      </template>
    </el-row>

    <!-- 查看公告详情 -->
    <el-dialog
      title="公告详情"
      :visible.sync="notice_show"
      width="1000px"
    >
      <span slot="title">
        <el-image class="notice_img" :src="info"></el-image>公告详情
      </span>
      <el-row class="mb40">
        <h2 style="text-align: center;">{{noticeInfo.noticeTitle}}</h2>
        <!-- <p class="t_r mb5" style="color: #ababab;">通知对象：全部班级</p> -->
        <p class="t_r mt5" style="color: #ababab;">
          发布人：{{noticeInfo.createByTeacherIdText || '-'}}
          <span style="margin-left: 20px;">发布时间：{{noticeInfo.createTime}}</span>
        </p>
        <el-row v-html="noticeInfo.noticeContent"></el-row>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="notice_show = false">取 消</el-button> -->
        <el-button type="primary" @click="notice_show = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 添加公告 -->
    <el-dialog
      title="添加公告"
      :visible.sync="addShow"
      width="800px"
    >
      <span slot="title">
        <i class="el-icon-bell mr10 font20 mt2" style="color: #409EFF;float: left;"></i>添加公告
      </span>
      <el-form ref="addInfo" :model="addInfo" label-width="80px">
        <el-form-item label="公告标题">
          <el-input v-model="addInfo.noticeTitle" placeholder="请输入公告标题"></el-input>
        </el-form-item>
        <el-form-item label="通知对象">
          <!-- 需求：已经进入某个课程，通知对象固定为当前课程，不再让用户自行选择课程 -->
          <template v-if="courseId">
            <div class="notice_locked_course">
              <i class="el-icon-collection-tag"></i>
              <span class="notice_locked_name">{{currentCourseName}}</span>
              <span class="notice_locked_tip">已进入本课程，通知对象固定为当前课程</span>
            </div>
            <el-select clearable filterable multiple collapse-tags v-model="addInfo.schoolClassIds" placeholder="全部班级">
              <template v-for="(item, index) in classList">
                <el-option :key="index+'class'" :label="item.schoolClassIdText" :value="item.schoolClassId"></el-option>
              </template>
            </el-select>
          </template>
          <!-- 兜底：未进入课程（如个人工作台挂件）时才允许选择课程 -->
          <template v-else>
            <el-select @change="getClassInfoList()" clearable filterable multiple collapse-tags v-model="addInfo.teacherOpenCourseIds" placeholder="全部课程">
              <template v-for="(item, index) in courseList">
                <el-option :key="index+'class'" :label="item.teacherOpenCourseTitle" :value="item.teacherOpenCourseId"></el-option>
              </template>
            </el-select>
            <el-select clearable filterable multiple collapse-tags v-model="addInfo.schoolClassIds" placeholder="全部班级">
              <template v-for="(item, index) in classList">
                <el-option :key="index+'class'" :label="item.schoolClassIdText" :value="item.schoolClassId"></el-option>
              </template>
            </el-select>
          </template>
        </el-form-item>
        <el-form-item label="公告内容">
          <RichText ref="richText" v-model="addInfo.noticeContent" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addShow = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
import RichText from '@/components/RichText/index';
import {getClassInfo,getCourseInfo} from "@/common/getInfo";	//加载数据
export default {
  name: "Notice",
  components: {
  	TitleInfo,
  	RichText,
  },
  props: {
    borderShow: { //是否显示边框
      type: Boolean,
      default: function(){
        return true;
      }
    },
    pagingShow:{ //是否分页
      type: Boolean,
      default: function(){
        return true;
      }
    },
    list:{ //显示的数据
      type: Array,
      default: function(){
        return [];
      }
    },
    hei:{ //高度
      type: String,
      default: function(){
        return '';
      }
    },
    courseId:{ //高度
      type: String,
      default: function(){
        return '';
      }
    },

  },
  data() {
    return {
      info:require("../../../images/home/info@2x.png"),
      noticeList:[],

      total: 0,
      limit:5,
      page:1,
      notice_show:false,
      noticeInfo:{},
      addShow:false,
      courseList:[], //课程List
      classList:[], //班级List
      addInfo:{}, //添加的公告信息
      currentCourseName:'当前课程', //当前课程名称（通知对象锁定展示用）
    };
  },
  created() {

  },
  mounted() {
    if(this.list.length > 0){
      this.noticeList = this.list;
    }else if(this.pagingShow){
      this.getInfo();
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseIds:this.courseId
      }
      const identityInfo = this.$ls.get(this.$getKeyInfo("identityInfo"));
      param.createByTeacherId = identityInfo.teacherId; //教师id
      this.$post("/jlw/teacherOpenCourseNotice/list.json",param).then((ret) => {
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.noticeList = ret.data;
        }
      });
    },
    lookNotice(item){ //查看详情
      let param = {
        teacherOpenCourseNoticeId:item.teacherOpenCourseNoticeId
      }
      let onSuccess = item.studentIsRead;
      this.$get("/jlw/teacherOpenCourseNotice/view.json",param).then((ret) => {
        if(ret.code == 0){
          item.studentIsRead = true;
          this.noticeInfo = ret.data;
          this.notice_show = true;
          setTimeout(()=>{
            if(this.$Base64.decode(this.$ls.get(this.$getKeyInfo('userType')))  == 1 && !onSuccess){ //学生
              this.$emit("onSuccess");
            }
          },200);
        }
      });
    },
    addNotice(){ //新增公告
      // 先清空，再设置默认值，避免上次数据残留
      this.classList = [];
      this.addInfo = {};
      if(this.courseId){ //已进入课程：通知对象固定为当前课程，不可修改
        this.addInfo = {teacherOpenCourseIds:[this.courseId]};
        this.currentCourseName = '当前课程';
        this.getClassInfoList(); //联动加载当前课程的班级
      }
      this.addShow = true;
      // 拉取课程列表：锁定模式只为拿当前课程名称展示；兜底模式下作为可选课程数据源
      this.$get("/jlw/teacherOpenCourse/getMyselfValues.json",{'teacherOpenCourseStatus':1}).then((ret) => {
        if(ret.code == 0){
          this.courseList = ret.data;
          let cur = this.courseList.find((item) => item.teacherOpenCourseId == this.courseId);
          if(cur && !this.$isEmpty(cur.teacherOpenCourseTitle)){
            this.currentCourseName = cur.teacherOpenCourseTitle;
          }
        }
      });
    },
    getClassInfoList(){
      this.classList = [];
      if(this.$isEmpty(this.addInfo.teacherOpenCourseIds)){
        return;
      }
      // 修复班级不显示：接口只支持 teacherOpenCourseId 参数，多选课程时逐个查询后合并
      let list = [];
      this.addInfo.teacherOpenCourseIds.forEach((id) => {
        getClassInfo({teacherOpenCourseId:id}).then((ret) => {
          if(ret.code == 0 && ret.data){
            list = list.concat(ret.data);
            this.classList = list;
          }
        });
      });
    },
    submitAdd(){ //提交新增数据
      if(this.$isEmpty(this.addInfo.noticeTitle)){
        this.$message({message: '请输入公告标题！',type: 'warning'});
        return;
      }
      if(!this.$isEmpty(this.addInfo.teacherOpenCourseIds)){
        this.addInfo.teacherOpenCourseIds = this.addInfo.teacherOpenCourseIds.join(",");
        // this.$message({message: '请选择课程信息！',type: 'warning'});
        // return;
      }
      if(!this.$isEmpty(this.addInfo.schoolClassIds)){
        this.addInfo.schoolClassIds = this.addInfo.schoolClassIds.join(",");
        // this.$message({message: '请选择班级信息！',type: 'warning'});
        // return;
      }
      if(this.$isEmpty(this.addInfo.noticeContent)){
        this.$message({message: '请输入公告内容！',type: 'warning'});
        return;
      }
      this.$post("/jlw/teacherOpenCourseNotice/add.json",this.addInfo).then((ret) => {
        if(ret.code == 0){
          this.getInfo();
          this.addShow = false;
          this.$refs.richText.content = ""; //清空编辑框
          this.$message({message: '添加成功！',type: 'success'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });

    }
  },
  watch:{
    list:{
      handler(newVal){
        this.noticeList = newVal;
      }
    }
  }
};
</script>
 <style  lang="less">
  .el-notice{
    .notice_list{
      max-height: 400px;
      overflow: auto;
      border-top: none !important;
      .but_icon{
        width: 33%;height: 55px;float: left;text-align: center;
      }
    }
    .notice_img{
      width: 20px;
      height: 20px;
      margin-right: 10px;
      float: left;
    }
    .content_block{
      background-color: #ffffff;
      .el-divider--horizontal{
        margin: 0;
      }
    }
    ._Info_box{
      .title_head{
        padding: 10px 20px;
      }
      .title_img{
        width: 24px !important;
        float: left;
      }
      .class_img{
        float: left;margin-right: 10px;
      }
      .el-divider--horizontal{
        margin: 0;
      }
    }
    .wdon{
      width: 10px;height: 10px;background-color: red;border-radius: 50%;
      float: left;margin-top: 7px;margin-right: 10px;
    }
    //通知对象锁定区（已进入课程时不可选择）
    .notice_locked_course{
      display: flex;
      align-items: center;
      height: 32px;
      margin-bottom: 10px;
      padding: 0 12px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      background-color: #F5F7FA;
      i{
        color: #409EFF;
        margin-right: 8px;
      }
      .notice_locked_name{
        font-size: 14px;
        color: #303133;
        font-weight: 600;
        max-width: 60%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .notice_locked_tip{
        margin-left: auto;
        font-size: 12px;
        color: #909399;
      }
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/course/components/Notice.vue